export const ACTIONS = {
  INIT_ACTION: '@ngrx/store/init',
  INIT_ACTION_EFFECTS: '@ngrx/effects/init',
  UPDATE_ACTION: '@ngrx/store/update-reducers',
} as const;
